export enum CUSTOM_PORTMONE_PROVIDER_TITLE {
	NAFTOGAZ_UKRAINE = 'ГК "Нафтогаз України"',
}
